import { isAfter, startOfDay } from 'date-fns';
import * as timeModel from '../time';
import { UserRole } from '../UserInfoModel';
import { isSignatory, hasSignatorySigned, isBuyer } from './selectors';
/** Returns true if the relationship's effectiveDate is in the future. Meaning it's not in-effect yet. */ export function isFutureRelationship(param, now) {
    let { effectiveDate } = param;
    return !!effectiveDate && isAfter(effectiveDate instanceof Date ? effectiveDate : timeModel.fromDateStampObject(effectiveDate), startOfDay(now));
}
export const hasClientViewPermission = (role)=>role === UserRole.Owner || role === UserRole.Member;
export const hasUserSigned = (relationship, userId)=>{
    if (isSignatory(relationship, userId)) return hasSignatorySigned(relationship, userId);
    if (isBuyer(relationship, userId)) return relationship.approvalRecord !== null;
    return false;
};
